import {NotificationLevel} from '../data/general/notificationLevel.enum';

let swagger_url = process.env.REACT_APP_URL_SWAGGER;

export async function getUsers() {
	try {
		const response = await fetch(swagger_url + '/table/users', {
			method: 'GET',
			headers: {'Content-Type': 'application/json'}
		});

		let users = await response.json();

		console.log(users);
	} catch (err) {
		return null;
	}
}

export async function autocomplete(user: any, notify?: any) {
	try {
		const response = await fetch(swagger_url + '/seznam-uzivatelu-s-dodavateli/naseptavac', {
			method: 'POST',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify(user),
		});

		notify?.(NotificationLevel.SUCCESS, 'error.successDataSend');

		return await response.json();
	} catch (err) {
		notify?.(NotificationLevel.ERROR, 'error.internalServerError');
		return null;
	}
}

